import { PreviewCrossesModel } from './preview-crosses.model';
import { PreviewImportedCrossesModel } from './preview-imported-crosses.model';

export class SaveCrossesRequestModel {
    constructor(
        public crosses: PreviewCrossesModel[],
        public harvestDate: string,
        public harvestLocationId: number,
        public applyNewGroupToPreviousCrosses: boolean,
        public namingSource: NamingSource,
        public crossNamingSetting: CrossNameSetting,
        public fromImport: boolean,
        public importedCrosses?: PreviewImportedCrossesModel[]
    ) {
    }
}

export enum NamingSource {
    FROM_FILE,
    AUTOMATIC,
    MANUAL
}

export class CrossNameSetting {
    constructor(
        public prefix: string,
        public suffix: string,
        public addSpaceBetweenPrefixAndCode: boolean,
        public addSpaceBetweenSuffixAndCode: boolean,
        public numOfDigits: number,
        public separator: string,
        public saveParentageDesignationAsAString: boolean,
        public startNumber: number
    ) {
    }
}

export class CrossNamePresetSetting {
    constructor(
        public id?: number,
        public programUUID?: string,
        public toolId?: number,
        public toolSection?: string,
        public name?: string,
        public type?: string,
        public prefix?: string,
        public suffix?: string,
        public addSpaceBetweenPrefixAndCode?: boolean,
        public addSpaceBetweenSuffixAndCode?: boolean,
        public numOfDigits?: number,
        public separator?: string,
        public saveParentageDesignationAsAString?: boolean,
        public startNumber?: number
    ) {
    }
}
